import 'whatwg-fetch'
import {assertResponse} from './modules/assertResponse'
import {ErrorCodes} from '../constants/ErrorCodes'
import {WriterError} from '../error/WriterError'
import {Storage} from '../storage/Storage'

const getLocalConfig = () => {
    const settings = new Storage('__settings__')
    return settings.get('__global__', 'localConfiguration', false)
}

/**
 * Load configuration from url
 *
 * @return {Promise<object>}
 */
const loadConfiguration = () => {

    const localConfiguration = getLocalConfig()

    if (localConfiguration !== false) {
        return Promise.resolve(localConfiguration)
    }

    const {location} = window
    let url = `${location.protocol}//${location.host}`

    url += `/api/config/`

    return fetch(url)
        .then(response => assertResponse(response, {
            400: ErrorCodes.WRITERCONFIG_BAD_REQUEST,
            500: ErrorCodes.WRITERCONFIG_INTERNAL_SERVER_ERROR
        }))
        .then(response => response.json())
        .catch(ex => {
            throw ex
        })
}

/**
 *
 * @param configuration
 *
 * @throws {Error}
 * @returns {object}
 */
const assertConfiguration = (configuration) => {
    if (!configuration || !Array.isArray(configuration.plugins)) {
        throw new WriterError(ErrorCodes.WRITERCONFIG_CLIENT_ERROR, new Error('Configuration, or plugins array missing in configuration file'))
    }

    return configuration
}

/**
 * Count the number of enabled unique plugins to load
 *
 * @param  {Object} configuration Configuration json object
 * @return {int}
 */
const activePlugins = (configuration) => {
    let noOfPlugins = 0

    if (configuration && Array.isArray(configuration.plugins)) {
        const pluginCounted = []
        noOfPlugins = configuration.plugins.reduce((acc, plugin) => {
            if (pluginCounted.includes(plugin.name)) {
                return acc
            }
            pluginCounted.push(plugin.name)
            return plugin.enabled ? acc + 1 : acc
        }, 0)
    }

    return noOfPlugins
}


export {loadConfiguration, assertConfiguration, activePlugins}
